import { api } from "../../server/request";
import { processMergeData } from "../../UserScreen/AnalyticsDashboard/service";
import { SET_ANALYTICS_TOP_CARDS_LOADING, SET_ANALYTICS_BAR_CHART_LOADING, GET_ANALYTICS_BAR_CHART, SET_ANALYTICS_LINE_CHART_LOADING, GET_ANALYTICS_LINE_CHART, GET_ANALYTICS_TOP_CARDS, SET_ANALYTICS_TABLE_LOADING, GET_ANALYTICS_TABLE } from "../types";

export const getAnalyticsTopCards = (topWidgetQueries, fullPayload, analyticsData, activeTab, subTab) => async (dispatch) => {
    dispatch({ type: SET_ANALYTICS_TOP_CARDS_LOADING, payload: true });

    try {
        const results = await Promise.all(
            topWidgetQueries.map(async ({ name, parameters }) => {
                try {
                    const filteredPayload = Object.fromEntries(
                        parameters.map((key) => [key, fullPayload[key]]).filter(([_, value]) => value !== undefined)
                    );
                    const res = await api.postRequestOut(`/store/ch/query`, {
                        query: name,
                        named: true,
                        format: "json",
                        parameters: filteredPayload
                    });

                    return res?.data?.data || {};
                } catch (error) {
                    console.error('Error fetching data for', name, error);
                    return {};
                }
            })
        );
        const flattenedResults = results.flat();
        const mergedData = processMergeData(flattenedResults, analyticsData, activeTab, subTab);

        dispatch({
            type: GET_ANALYTICS_TOP_CARDS,
            payload: {
                ...analyticsData?.[activeTab]?.[subTab]?.topWidget,
                ...mergedData
            }
        });

    } catch (error) {
        dispatch({ type: SET_ANALYTICS_TOP_CARDS_LOADING, payload: false });
        console.error('Error in getAnalyticsTopCards:', error);
    }
};

export const getAnalyticsLeftChart = (leftChartQueries, fullPayload, analyticsData, activeTab, subTab) => async (dispatch) => {
    dispatch({ type: SET_ANALYTICS_BAR_CHART_LOADING, payload: true });

    try {
        const results = await Promise.all(
            leftChartQueries.map(async ({ name, parameters }) => {
                try {
                    const filteredPayload = Object.fromEntries(
                        parameters.map((key) => [key, fullPayload[key]]).filter(([_, value]) => value !== undefined)
                    );
                    const res = await api.postRequestOut(`/store/ch/query`, {
                        query: name,
                        named: true,
                        format: "json",
                        parameters: filteredPayload
                    });
                    return res?.data?.data || {};
                } catch (error) {
                    console.error('Error fetching data for', name, error);
                    return {};
                }
            })
        );
        const flattenedResults = results.flat();

        dispatch({
            type: GET_ANALYTICS_BAR_CHART,
            payload: flattenedResults,
        });

    } catch (error) {
        dispatch({ type: SET_ANALYTICS_BAR_CHART_LOADING, payload: false });
        console.error('Error in getAnalyticsTopCards:', error);
    }
};

export const getAnalyticsRightChart = (rightChartQueries, fullPayload, analyticsData, activeTab, subTab) => async (dispatch) => {
    dispatch({ type: SET_ANALYTICS_LINE_CHART_LOADING, payload: true });

    try {
        const results = await Promise.all(
            rightChartQueries.map(async ({ name, parameters, groupBy, series, tsColumn }) => {
                try {
                    const filteredPayload = Object.fromEntries(
                        parameters.map((key) => [key, fullPayload[key]]).filter(([_, value]) => value !== undefined)
                    );
                    const res = await api.postRequestOut(`/store/ch/query`, {
                        query: name,
                        named: true,
                        format: "chart",
                        groupBy: groupBy || "",
                        series: series || "",
                        tsColumn: tsColumn || "",
                        parameters: filteredPayload
                    });
                    return res?.data?.data || {};
                } catch (error) {
                    console.error('Error fetching data for', name, error);
                    return {};
                }
            })
        );
        const flattenedResults = results.flat();

        dispatch({
            type: GET_ANALYTICS_LINE_CHART,
            payload: flattenedResults,
        });

    } catch (error) {
        dispatch({ type: SET_ANALYTICS_LINE_CHART_LOADING, payload: false });
        console.error('Error in getAnalyticsTopCards:', error);
    }
};

export const getAnalyticsTable = (tableQueries, fullPayload, analyticsData, activeTab, subTab) => async (dispatch) => {
    dispatch({ type: SET_ANALYTICS_TABLE_LOADING, payload: true });

    try {
        const results = await Promise.all(
            tableQueries.map(async ({ name, parameters }) => {
                try {
                    const filteredPayload = Object.fromEntries(
                        parameters.map((key) => [key, fullPayload[key]]).filter(([_, value]) => value !== undefined)
                    );
                    const res = await api.postRequestOut(`/store/ch/query`, {
                        query: name,
                        named: true,
                        format: "json",
                        parameters: filteredPayload
                    });
                    return res?.data?.data || {};
                } catch (error) {
                    console.error('Error fetching data for', name, error);
                    return {};
                }
            })
        );
        const flattenedResults = results.flat();

        dispatch({
            type: GET_ANALYTICS_TABLE,
            payload: flattenedResults,
        });
        return flattenedResults;
    } catch (error) {
        dispatch({ type: SET_ANALYTICS_TABLE_LOADING, payload: false });
        console.error('Error in getAnalyticsTopCards:', error);
    }
};